exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#contact .card:hover i,#contact .card:hover h4{\n\tcolor: #87d37c;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/user/contact-us/contact-us.component.css
// module id = ../../../../../src/app/user/contact-us/contact-us.component.css
// module chunks = main